__turbopack_context__.v({
  "colorBlue": "AIShowcaseItem-module-scss-module__jOwkXa__colorBlue",
  "colorGreen": "AIShowcaseItem-module-scss-module__jOwkXa__colorGreen",
  "colorOrange": "AIShowcaseItem-module-scss-module__jOwkXa__colorOrange",
  "colorPink": "AIShowcaseItem-module-scss-module__jOwkXa__colorPink",
  "featureItem": "AIShowcaseItem-module-scss-module__jOwkXa__featureItem",
  "featuresList": "AIShowcaseItem-module-scss-module__jOwkXa__featuresList",
  "item": "AIShowcaseItem-module-scss-module__jOwkXa__item",
  "titleLabel": "AIShowcaseItem-module-scss-module__jOwkXa__titleLabel",
  "titleLabelRoot": "AIShowcaseItem-module-scss-module__jOwkXa__titleLabelRoot",
  "visible": "AIShowcaseItem-module-scss-module__jOwkXa__visible",
});
